{
  "is_in_stack": {
    "source": "stackdx",
    "domainType": "boolean",
    "ui": {
      "label": "Is In StackDX",
      "folder": "StackDX",
      "isShownByDefault": true,
    },
    "gpt": {
      "hint": "Indicates if a well is included in user's private company data (land system, StackDX, etc.)",
    },
  },
  "stack_company_well_id": {
    "source": "stackdx",
    "domainType": "string",
    "ui": {
      "label": "Company Well ID [StackDX]",
      "folder": "StackDX",
    },
  },
  "stack_surface_location_for_matching": {
    "source": "stackdx",
    "domainType": "string",
    "ui": {
      "label": "Surface Location for Matching [StackDX]",
      "folder": "StackDX",
    },
  },
  "stack_surface_location_from_land": {
    "source": "stackdx",
    "domainType": "string",
    "ui": {
      "label": "Surface Location from Land [StackDX]",
      "folder": "StackDX",
    },
  },
  "stack_surface_latitude": {
    "source": "stackdx",
    "domainType": "number",
    "ui": {
      "label": "Surface Latitude [StackDX]",
      "folder": "StackDX",
    },
  },
  "stack_surface_longitude": {
    "source": "stackdx",
    "domainType": "number",
    "ui": {
      "label": "Surface Longitude [StackDX]",
      "folder": "StackDX",
    },
  },
  "stack_bottom_latitude": {
    "source": "stackdx",
    "domainType": "number",
    "ui": {
      "label": "Bottom Latitude [StackDX]",
      "folder": "StackDX",
    },
  },
  "stack_bottom_longitude": {
    "source": "stackdx",
    "domainType": "number",
    "ui": {
      "label": "Bottom Longitude [StackDX]",
      "folder": "StackDX",
    },
  },
  "stack_is_active": {
    "source": "stackdx",
    "domainType": "boolean",
    "ui": {
      "label": "Is Active [StackDX]",
      "folder": "StackDX",
    },
  },
  "stack_well_key_from_land": {
    "source": "stackdx",
    "domainType": "string",
    "ui": {
      "label": "Well Key From Land [StackDX]",
      "folder": "StackDX",
    },
  },
  "stack_well_name": {
    "source": "stackdx",
    "domainType": "string",
    "ui": {
      "label": "Well Name [StackDX]",
      "folder": "StackDX",
    },
  },
  "stack_file_status_desc": {
    "source": "stackdx",
    "domainType": "string",
    "ui": {
      "label": "File Status Description [StackDX]",
      "folder": "StackDX",
    },
  },
  "stack_well_status_desc": {
    "source": "stackdx",
    "domainType": "string",
    "ui": {
      "label": "Well Status Description [StackDX]",
      "folder": "StackDX",
    },
  },
  "stack_well_type_desc": {
    "source": "stackdx",
    "domainType": "string",
    "ui": {
      "label": "Well Type Description [StackDX]",
      "folder": "StackDX",
    },
  },
  "stack_fluid_desc": {
    "source": "stackdx",
    "domainType": "string",
    "ui": {
      "label": "Fluid Description [StackDX]",
      "folder": "StackDX",
    },
  },
  "stack_cost_centre_code": {
    "source": "stackdx",
    "domainType": "string",
    "ui": {
      "label": "Cost Centre Code [StackDX]",
      "folder": "StackDX",
    },
  },
  "stack_cost_centre_desc": {
    "source": "stackdx",
    "domainType": "string",
    "ui": {
      "label": "Cost Centre Description [StackDX]",
      "folder": "StackDX",
    },
  },
  "stack_licensee_ba_name": {
    "source": "stackdx",
    "domainType": "string",
    "ui": {
      "label": "Licensee BA Name [StackDX]",
      "folder": "StackDX",
    },
  },
  "stack_licence_id": {
    "source": "stackdx",
    "domainType": "string",
    "ui": {
      "label": "Licence ID [StackDX]",
      "folder": "StackDX",
    },
  },
  "stack_government_well_status": {
    "source": "stackdx",
    "domainType": "string",
    "ui": {
      "label": "Government Well Status [StackDX]",
      "folder": "StackDX",
    },
  },
  "stack_shutin_reason": {
    "source": "stackdx",
    "domainType": "string",
    "ui": {
      "label": "Shut-in Reason [StackDX]",
      "folder": "StackDX",
    },
  },
  "stack_direction_drilled_desc": {
    "source": "stackdx",
    "domainType": "string",
    "ui": {
      "label": "Direction Drilled Description [StackDX]",
      "folder": "StackDX",
    },
  },
  "stack_producing_zone_desc": {
    "source": "stackdx",
    "domainType": "string",
    "ui": {
      "label": "Producing Zone Description [StackDX]",
      "folder": "StackDX",
    },
  },
  "stack_governing_contract_operator_ba_name": {
    "source": "stackdx",
    "domainType": "string",
    "ui": {
      "label": "Governing Contract Operator BA Name [StackDX]",
      "folder": "StackDX",
    },
  },
  "stack_governing_contract_number": {
    "source": "stackdx",
    "domainType": "string",
    "ui": {
      "label": "Governing Contract Number [StackDX]",
      "folder": "StackDX",
    },
  },
  "stack_contract_operator_ba_name": {
    "source": "stackdx",
    "domainType": "string",
    "ui": {
      "label": "Contract Operator BA Name [StackDX]",
      "folder": "StackDX",
    },
  },
  "stack_division_desc": {
    "source": "stackdx",
    "domainType": "string",
    "ui": {
      "label": "Division Description [StackDX]",
      "folder": "StackDX",
    },
  },
  "stack_district_desc": {
    "source": "stackdx",
    "domainType": "string",
    "ui": {
      "label": "District Description [StackDX]",
      "folder": "StackDX",
    },
  },
  "stack_area_desc": {
    "source": "stackdx",
    "domainType": "string",
    "ui": {
      "label": "Area Description [StackDX]",
      "folder": "StackDX",
    },
  },
  "stack_area_province": {
    "source": "stackdx",
    "domainType": "string",
    "ui": {
      "label": "Area Province [StackDX]",
      "folder": "StackDX",
    },
  },
  "stack_field_desc": {
    "source": "stackdx",
    "domainType": "string",
    "ui": {
      "label": "Field Description [StackDX]",
      "folder": "StackDX",
    },
  },
  "stack_pool_desc": {
    "source": "stackdx",
    "domainType": "string",
    "ui": {
      "label": "Pool Description [StackDX]",
      "folder": "StackDX",
    },
  },
  "stack_admin_ba_name": {
    "source": "stackdx",
    "domainType": "string",
    "ui": {
      "label": "Admin BA Name [StackDX]",
      "folder": "StackDX",
    },
  },
  "stack_file_status_date": {
    "source": "stackdx",
    "domainType": "DateString",
    "ui": {
      "label": "File Status Date [StackDX]",
      "folder": "StackDX",
    },
  },
  "stack_well_status_date": {
    "source": "stackdx",
    "domainType": "DateString",
    "ui": {
      "label": "Well Status Date [StackDX]",
      "folder": "StackDX",
    },
  },
  "stack_true_vert_depth": {
    "source": "stackdx",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m",
    },
    "ui": {
      "label": "True Vertical Depth [StackDX]",
      "folder": "StackDX",
    },
  },
  "stack_total_depth": {
    "source": "stackdx",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "m",
    },
    "ui": {
      "label": "Total Depth [StackDX]",
      "folder": "StackDX",
    },
  },
  "stack_licence_date": {
    "source": "stackdx",
    "domainType": "DateString",
    "ui": {
      "label": "Licence Date [StackDX]",
      "folder": "StackDX",
    },
  },
  "stack_spud_date": {
    "source": "stackdx",
    "domainType": "DateString",
    "ui": {
      "label": "Spud Date [StackDX]",
      "folder": "StackDX",
    },
  },
  "stack_rig_release_date": {
    "source": "stackdx",
    "domainType": "DateString",
    "ui": {
      "label": "Rig Release Date [StackDX]",
      "folder": "StackDX",
    },
  },
  "stack_on_production_date": {
    "source": "stackdx",
    "domainType": "DateString",
    "ui": {
      "label": "On Production Date [StackDX]",
      "folder": "StackDX",
    },
  },
  "stack_last_prod_date": {
    "source": "stackdx",
    "domainType": "DateString",
    "ui": {
      "label": "Last Production Date [StackDX]",
      "folder": "StackDX",
    },
  },
  "stack_surface_abandoned_date": {
    "source": "stackdx",
    "domainType": "DateString",
    "ui": {
      "label": "Surface Abandoned Date [StackDX]",
      "folder": "StackDX",
    },
  },
  "stack_internal_event_code": {
    "source": "stackdx",
    "domainType": "string",
    "ui": {
      "label": "Internal Event Code [StackDX]",
      "folder": "StackDX",
    },
  },
  "stack_internal_pad_code": {
    "source": "stackdx",
    "domainType": "string",
    "ui": {
      "label": "Internal Pad Code [StackDX]",
      "folder": "StackDX",
    },
  },
  "stack_link": {
    "source": "stackdx",
    "domainType": "string",
    "ui": {
      "label": "N/A",
      "folder": "N/A",
      "isNotRenderable": true,
    },
  },
}
